/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../../utils/secure-route/AuthContext";
import CustomInput from "../../custominput/CustomInput";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import config from "../../../config/Global.json";

const LoginPage = () => {
  const { loginUser, authToken, setManualAuthToken } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (authToken) {
      navigate("/");
    }
  }, [authToken]);

  const [errors, setErrors] = useState({});
  const [customErr, setCustomErr] = useState(false);
  const [customErrMsg, setCustomErrMsg] = useState("");
  const [passError, setPassError] = useState(false);
  const [passErrMsg, setPassErrMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loginMode, setLoginMode] = useState("password");
  const [email, setEmail] = useState("");
  const [loginOtp, setLoginOtp] = useState("");
  const [otpSending, setOtpSending] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);

  const checkValidUsername = (username) => {
    const emailRegex = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(username)) {
      setErrors((prevErrors) => ({ ...prevErrors, username: true }));
      setCustomErr(true);
      setCustomErrMsg("Please enter a valid email address.");
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, username: "" }));
      setCustomErr(false);
      setCustomErrMsg("");
    }
  };

  const checkValidPassword = (password) => {
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>_\-])[A-Za-z\d!@#$%^&*(),.?":{}|<>_\-]{8,}$/;

    if (!passwordRegex.test(password)) {
      setErrors((prevErrors) => ({ ...prevErrors, password: true }));
      setPassError(true);
      setPassErrMsg(
        "Password must be at least 8 characters, with one uppercase letter, one digit, and one special character."
      );
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
      setPassError(false);
      setPassErrMsg("");
    }
  };

  const handleSocialLogin = async (provider) => {
    try {
      const response = await axios.get(
        `${config.api.host}${config.api.socialAuthStart}${provider}/start/?mode=login`
      );
      if (response.data?.redirect_url) {
        window.location.href = response.data.redirect_url;
      }
    } catch (error) {
      toast.error(error.response?.data?.error || `${provider} login is not configured yet.`);
    }
  };

  const requestLoginOtp = async () => {
    const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      checkValidUsername(email);
      return;
    }

    setOtpSending(true);
    try {
      await axios.post(`${config.api.host}${config.api.loginEmailOtpRequest}`, {
        email,
      });
      setOtpSent(true);
      toast.success("Login code sent to your email.");
    } catch (error) {
      toast.error(error.response?.data?.error || "Could not send login code.");
    } finally {
      setOtpSending(false);
    }
  };

  const verifyLoginOtp = async (event) => {
    event.preventDefault();
    if (!email || loginOtp.length !== 6) {
      toast.error("Enter your email and 6 digit login code.");
      return;
    }

    setOtpVerifying(true);
    try {
      const response = await axios.post(`${config.api.host}${config.api.loginEmailOtpVerify}`, {
        email,
        otp: loginOtp,
      });
      setManualAuthToken(response.data);
      toast.success("Login successful! Welcome back!");
      navigate("/");
    } catch (error) {
      toast.error(error.response?.data?.error || "Invalid or expired login code.");
    } finally {
      setOtpVerifying(false);
    }
  };

  return (
    <div className="auth-form auth-login-form">
      <ToastContainer />
      <style>{loginStyles}</style>

      <div className="auth-form-header">
        <div className="auth-form-badge">Secure Login</div>
        <h1>Welcome Back</h1>
        <p>Access your business command center.</p>
      </div>

      <div className="auth-social-grid">
        <button type="button" className="auth-social-btn" onClick={() => handleSocialLogin("google")}>
          <span className="auth-google-logo">G</span>
          Gmail
        </button>

        <button type="button" className="auth-social-btn" onClick={() => handleSocialLogin("facebook")}>
          <span className="auth-facebook-logo">f</span>
          Facebook
        </button>
      </div>

      <div className="auth-divider">
        <span />
        <p>or continue with email</p>
        <span />
      </div>

      <div className="auth-mode-toggle">
        <button
          type="button"
          className={loginMode === "password" ? "active" : ""}
          onClick={() => setLoginMode("password")}
        >
          Password
        </button>
        <button
          type="button"
          className={loginMode === "otp" ? "active" : ""}
          onClick={() => setLoginMode("otp")}
        >
          Email OTP
        </button>
      </div>

      <form onSubmit={loginMode === "password" ? loginUser : verifyLoginOtp} className="auth-field-stack">
        <div className="auth-field">
          <label htmlFor="username">Email Address</label>
          <CustomInput
            type="text"
            id="username"
            name="username"
            placeholder="Enter your email"
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
              setOtpSent(false);
              setLoginOtp("");
            }}
            onBlur={(event) => checkValidUsername(event.target.value)}
            custom={customErr}
            msg={customErrMsg}
            required
            error={Boolean(errors.username)}
            helpertext={errors.username}
          />
        </div>

        {loginMode === "password" ? (
          <div className="auth-field">
            <label htmlFor="password">Password</label>
            <div className="auth-password-wrap">
              <CustomInput
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                placeholder="Enter your password"
                required
                onBlur={(event) => checkValidPassword(event.target.value)}
                custom={passError}
                msg=""
                error={Boolean(errors.password)}
                helpertext=""
              />

              <button
                type="button"
                className="auth-password-toggle"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                <img
                  src={
                    showPassword
                      ? require("../../../assets/img/hidden.png")
                      : require("../../../assets/img/show.png")
                  }
                  alt=""
                />
              </button>
            </div>

            {passError && <div className="auth-error-text">{passErrMsg}</div>}
          </div>
        ) : (
          <div className="auth-otp-login-card">
            <div>
              <strong>Login without password</strong>
              <span>We will email a secure 6 digit code to this account.</span>
            </div>
            <div className="auth-otp-login-row">
              <button type="button" onClick={requestLoginOtp} disabled={otpSending || !email || customErr}>
                {otpSending ? "Sending..." : otpSent ? "Resend Code" : "Send Code"}
              </button>
              <input
                value={loginOtp}
                onChange={(event) => setLoginOtp(event.target.value.replace(/\D/g, "").slice(0, 6))}
                placeholder="000000"
                inputMode="numeric"
                maxLength={6}
              />
            </div>
          </div>
        )}

        <div className="auth-form-options">
          <label className="auth-check">
            <input type="checkbox" id="rememberMe" />
            <span>Remember me</span>
          </label>

          <Link to="/forgot-password" className="auth-link">
            Forgot Password?
          </Link>
        </div>

        <button type="submit" className="auth-primary-btn" disabled={loginMode === "otp" && otpVerifying}>
          {loginMode === "otp" ? (otpVerifying ? "Verifying..." : "Verify & Login") : "Login Securely"}
        </button>
      </form>

      <div className="auth-bottom-text">
        <span>New to Paisa Vara?</span>
        <Link to="/create-user">Create Store & Account</Link>
      </div>
    </div>
  );
};

export default LoginPage;

const loginStyles = `
  .auth-form {
    width: 100%;
  }

  .auth-form-header {
    margin-bottom: 20px;
  }

  .auth-form-badge {
    display: inline-flex;
    padding: 7px 11px;
    border-radius: 10px;
    margin-bottom: 12px;
    color: #0d532f;
    font-size: 10px;
    font-weight: 950;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    background: #ecfdf5;
    border: 1px solid #a7f3d0;
  }

  .auth-form-header h1 {
    margin: 0;
    color: #0f172a;
    font-size: 34px;
    line-height: 1.05;
    font-weight: 950;
    letter-spacing: -0.06em;
  }

  .auth-form-header p {
    margin: 7px 0 0;
    color: #64748b;
    font-size: 13px;
    font-weight: 750;
  }

  .auth-social-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 9px;
    margin-bottom: 16px;
  }

  .auth-social-btn {
    height: 46px;
    border: 1px solid #dbe3ec;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    background: #ffffff;
    color: #0f172a;
    font-size: 12px;
    font-weight: 950;
    cursor: pointer;
    transition: transform 0.16s ease, box-shadow 0.16s ease, border 0.16s ease;
  }

  .auth-social-btn:hover {
    transform: translateY(-1px);
    border-color: #94a3b8;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.10);
  }

  .auth-google-logo,
  .auth-facebook-logo {
    width: 21px;
    height: 21px;
    border-radius: 7px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 950;
  }

  .auth-google-logo {
    color: #ea4335;
    background: #fff1f2;
  }

  .auth-facebook-logo {
    color: #ffffff;
    background: #1877f2;
    font-family: Arial, sans-serif;
    font-size: 16px;
  }

  .auth-divider {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 10px;
    margin: 6px 0 16px;
  }

  .auth-divider span {
    height: 1px;
    background: #e2e8f0;
  }

  .auth-divider p {
    margin: 0;
    color: #94a3b8;
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  .auth-field-stack {
    display: grid;
    gap: 14px;
  }

  .auth-mode-toggle {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    padding: 5px;
    margin: 0 0 14px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #f8fafc;
  }

  .auth-mode-toggle button {
    height: 40px;
    border: none;
    border-radius: 9px;
    background: transparent;
    color: #64748b;
    font-size: 12px;
    font-weight: 950;
    cursor: pointer;
  }

  .auth-mode-toggle button.active {
    background: #ffffff;
    color: #0d532f;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  }

  .auth-field label {
    display: block;
    margin-bottom: 7px;
    color: #334155;
    font-size: 12px;
    font-weight: 950;
    letter-spacing: 0.02em;
  }

  .auth-field input,
  .auth-field .form-control {
    height: 50px !important;
    min-height: 50px !important;
    border-radius: 10px !important;
    border-color: #cbd5e1 !important;
    font-weight: 750;
    box-shadow: none !important;
  }

  .auth-field input:focus,
  .auth-field .form-control:focus {
    border-color: #0d532f !important;
    box-shadow: 0 0 0 4px rgba(13, 83, 47, 0.10) !important;
  }

  .auth-password-wrap {
    position: relative;
  }

  .auth-password-toggle {
    position: absolute;
    top: 50%;
    right: 9px;
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 9px;
    background: #f8fafc;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 4;
  }

  .auth-password-toggle img {
    width: 21px;
    height: 21px;
    object-fit: contain;
    opacity: 0.72;
  }

  .auth-error-text {
    color: #dc2626;
    font-size: 12px;
    font-weight: 750;
    margin-top: 6px;
    line-height: 1.45;
  }

  .auth-otp-login-card {
    display: grid;
    gap: 12px;
    padding: 14px;
    border-radius: 12px;
    border: 1px solid #bbf7d0;
    background: #f0fdf4;
  }

  .auth-otp-login-card strong {
    display: block;
    color: #14532d;
    font-size: 13px;
    font-weight: 950;
  }

  .auth-otp-login-card span {
    display: block;
    margin-top: 3px;
    color: #64748b;
    font-size: 12px;
    font-weight: 750;
    line-height: 1.45;
  }

  .auth-otp-login-row {
    display: grid;
    grid-template-columns: 130px 1fr;
    gap: 8px;
  }

  .auth-otp-login-row button {
    height: 44px;
    border: none;
    border-radius: 10px;
    background: #0d532f;
    color: #ffffff;
    font-size: 12px;
    font-weight: 950;
    cursor: pointer;
  }

  .auth-otp-login-row button:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }

  .auth-otp-login-row input {
    height: 44px;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    padding: 0 12px;
    font-size: 18px;
    font-weight: 950;
    letter-spacing: 0.18em;
    text-align: center;
  }

  .auth-form-options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .auth-check {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #475569;
    font-size: 13px;
    font-weight: 800;
    cursor: pointer;
  }

  .auth-check input {
    width: 16px;
    height: 16px;
    accent-color: #0d532f;
  }

  .auth-link {
    color: #0d532f;
    text-decoration: none;
    font-size: 13px;
    font-weight: 950;
  }

  .auth-primary-btn {
    width: 100%;
    height: 50px;
    border: none;
    border-radius: 12px;
    margin-top: 4px;
    background: linear-gradient(135deg, #0d532f 0%, #052e1a 100%);
    color: #ffffff;
    font-size: 15px;
    font-weight: 950;
    cursor: pointer;
    box-shadow: 0 18px 34px rgba(13, 83, 47, 0.22);
    transition: transform 0.16s ease, box-shadow 0.16s ease;
  }

  .auth-primary-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 22px 42px rgba(13, 83, 47, 0.28);
  }

  .auth-bottom-text {
    display: flex;
    justify-content: center;
    gap: 6px;
    flex-wrap: wrap;
    margin-top: 20px;
    color: #64748b;
    font-size: 13px;
    font-weight: 750;
  }

  .auth-bottom-text a {
    color: #0d532f;
    text-decoration: none;
    font-weight: 950;
  }

  .auth-link:hover,
  .auth-bottom-text a:hover {
    text-decoration: underline;
  }

  @media (max-width: 560px) {
    .auth-form-header h1 {
      font-size: 29px;
    }

    .auth-social-grid {
      grid-template-columns: 1fr;
    }

    .auth-otp-login-row {
      grid-template-columns: 1fr;
    }

    .auth-form-options {
      align-items: flex-start;
      flex-direction: column;
    }
  }
`;
